const homepage = () => {
  // internal functions call from here...
  homepageHeroBanner();
  homepageProductCarousel();
  homepageTabCollection();
  homepageCollectionCarousel();
  runText();
  sizesAddtoCart();
  mobileQuickAdd();

  // Bind to the resize event of the window object
  $(window)
    .on('resize', function () {
      homepageDropDownCollection();
      // Invoke the resize event immediately
    })
    .resize();

  // Trigger slick in homepage hero banner when customizing theme
  $(window).on('shopify-custom-banner-slider-event', function () {
    homepageHeroBanner();
  });

  // homepage hero banner slick init and settings
  function homepageHeroBanner() {
    const heroEl = $('#hero-banner-slider');
    if (heroEl) {
      let settings = {
        arrows: false,
        dots: true,
        draggable: true,
        verticalSwiping: true,

        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        prevArrow: `<img class='slick-prev' src='//cdn.shopify.com/s/files/1/0622/3416/5414/t/105/assets/icon-arrow-light.svg'>`,
        nextArrow: `<img class='slick-next' src='//cdn.shopify.com/s/files/1/0622/3416/5414/t/105/assets/icon-arrow-light.svg'>`,
      };
      if ($(window).width() <= 768) {
        settings = {
          dots: true,
          arrows: false,
          draggable: true,
          verticalSwiping: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: `<img class='slick-prev' src='//cdn.shopify.com/s/files/1/0622/3416/5414/t/105/assets/icon-arrow-light.svg'>`,
          nextArrow: `<img class='slick-next' src='//cdn.shopify.com/s/files/1/0622/3416/5414/t/105/assets/icon-arrow-light.svg'>`,
        };
      }
      heroEl.slick(settings);
    }
  }
  /*
    $(document).ready(function() {
        var isHovered = false;
        var defaultLeft = '28%';
        var defaultTop = '50%';
    
        $('.homepage-banner-slider').on('mouseenter', function() {
          isHovered = true;
          $('.homepage-banner-slider').css('cursor', 'none');
        });
    
        $('.homepage-banner-slider').on('mousemove', function(e) {

          if ($('#textcursor').position().top < $('.homepage-banner-slider').height()) { 
            var containerOffset = $(this).offset();
            var relativeX = e.pageX - containerOffset.left;
            var relativeY = e.pageY - containerOffset.top;
      
            $('#textcursor').css({
              left: relativeX + 'px',
              top: relativeY + 'px'
            });
          }
          else {
            isHovered = false;
            $('.homepage-banner-slider').css('cursor', 'auto');
            $('#textcursor').css({
              left: defaultLeft,
              top: defaultTop
            });
          }
          
        });
    
        $('.homepage-banner-slider').on('mouseleave', function() {
          isHovered = false;
          $('.homepage-banner-slider').css('cursor', 'auto');
          $('#textcursor').css({
            left: defaultLeft,
            top: defaultTop
          });
        });

        $('.slick-dots').on('mouseenter', function() {
          $('.homepage-banner-slider').css('cursor', 'auto');
          $('#textcursor').css({
            left: defaultLeft,
            top: defaultTop
          });
        });
    
        $(document).on('mousemove', function() {
          if (!isHovered) {
            $('.homepage-banner-slider').css('cursor', 'none');
          }
        });
      });

    */

  // home page product carousel settings

  function sliderSettings(sliderParent) {
    return {
      arrows: false,
      dots: false,
      draggable: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
      ],
    };
  }

  // homepage product carousel section
  function homepageProductCarousel() {
    const slider = $('.homepage-product-slider');
    const sliderParent = $('#homepage-product-carousel').attr('class');

    if (slider) {
      slider.slick(sliderSettings());
    }

    const prevBtn = $(`.${sliderParent}`).find('.prev');
    const prev = $(`.${sliderParent}`).find('.slick-prev');
    const nextBtn = $(`.${sliderParent}`).find('.next');
    const next = $(`.${sliderParent}`).find('.slick-next');

    // specific slider controls
    $(prevBtn).on('click', function () {
      $(prev).trigger('click');
    });
    $(nextBtn).on('click', function () {
      $(next).trigger('click');
    });
  }

  function homepageCollectionCarousel() {
    const tabSlider = $('.highend_tab:first-child ul#product-grid');
    const tab = $('.homepage-highend-styling-tabs');

    // init first product carousel
    if (tabSlider) {
      tabSlider.slick(sliderSettings());

      const prevBtn = $(tabSlider).parent().find('.prev');
      const prev = $(tabSlider).parent().find('.slick-prev');
      const nextBtn = $(tabSlider).parent().find('.next');
      const next = $(tabSlider).parent().find('.slick-next');

      // specific slider controls
      $(prevBtn).on('click', function () {
        $(prev).trigger('click');
      });
      $(nextBtn).on('click', function () {
        $(next).trigger('click');
      });
    }

    // init slider and controls for slider blocks
    $(tab)
      .find('li')
      .on('click', function () {
        const activeTab = $(this).find('a').attr('href');
        const activeClass = $(this).find('a').attr('class');
        const conditionB = $(activeTab)
          .find('#product-grid')
          .hasClass(`highend_product_carousel_${activeClass}`);
        const conditionB2 = $(activeTab)
          .find(`.highend_product_carousel_${activeClass}`)
          .hasClass('slick-initialized');

        conditionB && !conditionB2
          ? $(activeTab)
              .find(`.highend_product_carousel_${activeClass}`)
              .slick(sliderSettings())
          : '';

        const prevBtn = $(activeTab).find('.prev');
        const nextBtn = $(activeTab).find('.next');
        const prev = $(activeTab).find('.slick-prev');
        const next = $(activeTab).find('.slick-next');

        // specific slider controls
        $(prevBtn).on('click', function () {
          $(prev).trigger('click');
        });
        $(nextBtn).on('click', function () {
          $(next).trigger('click');
        });
      });

    return false;
  }

  // homepage tabs collection
  function homepageTabCollection() {
    const tab = $('.homepage-highend-styling-tabs');

    // Show the first tab and hide the rest
    $(tab).find('li:first-child').addClass('active');
    $('.highend_tab').hide();
    $('.highend_tab:first').show();

    // Click function
    $(tab)
      .find('li')
      .on('click', function () {
        $(tab).find('li').removeClass('active');
        $(this).addClass('active');
        $('.highend_tab').hide();

        const activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
      });
  }

  // homepage tabs collection converted to dropdown when mobile version
  function homepageDropDownCollection() {
    // works for moble view only
    if ($(window).width() < 990) {
      $('.homepage-highend-styling-tabs .header').on('click', function () {
        $(this).parent().toggleClass('active');
        $(this)
          .parent()
          .find('li')
          .on('click', function () {
            const pk = $(this).closest('li').find('i').first().text();
            const txt = $(this).find('span').text();
            $(this).closest('ul').find('li a').removeClass('active'); // - $(this).closest('.options').find('span').removeClass('active');
            $(this).addClass('active');
            $(this)
              .parents('.homepage-highend-styling-tabs')
              .find('.selected')
              .text(txt);
            $(this)
              .parents('.homepage-highend-styling-tabs')
              .removeClass('active');
            $(this)
              .parents('.homepage-highend-styling-tabs')
              .find('.header')
              .find('input[name=category]')
              .val(pk);
          });
      });
    }
  }

  // homepage mobile blocks carousel 3,4,5
  /* Slick needs no get Reinitialized on window Resize after it was destroyed */
  $(window).on('load resize orientationchange', function () {
    $('.homepage-block-wrap.col_count_hide').each(function () {
      const $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() > 768) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      } else if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: false,
        });
      }
    });

    $('.homepage-block-wrap.col_count5').each(function () {
      const $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() > 768) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      } else if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: false,
        });
      }
    });

    $('.homepage-block-wrap.col_count4').each(function () {
      const $carousel = $(this);
      if ($(window).width() > 768) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      } else if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: false,
        });
      }
    });

    $('.homepage-block-wrap.col_count3').each(function () {
      const $carousel = $(this);
      if ($(window).width() > 768) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      } else if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: false,
        });
      }
    });
  });

  // homepage running text
  function runText() {
    /* GREENSOCK */
    /* TICKER <----------- Right */
  }

  // our store carousel setting
  function ourStoreCarousel() {
    $('.our-store-carousel ul').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: false,
      prevArrow: $('.our-store-slide-prev'),
      nextArrow: $('.our-store-slide-next'),
      responsive: [
        {
          breakpoint: 769,
          slidesToShow: 1,
        },
      ],
    });

    $(window).on('resize', function () {
      $('.our-store-carousel ul').slick('resize');
    });
  }

  ourStoreCarousel();

  // home page blocks

  function countHomeBlocks() {
    const elem = $('.homepage-block-wrap');

    $(elem).each(function () {
      const el_child = $(this).find('.homepage-custom-block').length;

      el_child == 2
        ? $(this).addClass('col_count2')
        : el_child == 3
          ? $(this).addClass('col_count3')
          : el_child == 4
            ? $(this).addClass('col_count4')
            : el_child == 5
              ? $(this).addClass('col_count5')
              : el_child > 5
                ? $(this).addClass('col_count_hide')
                : '';
    });
  }

  countHomeBlocks();

  // quick add
  function sizesAddtoCart() {
    const cartB =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');
    if ($(window).width() >= 990) {
      $('.variant-selector form button').click(function (e) {
        e.preventDefault();
        const $this = $(this);
        const variantId = $this.data('variant-id');
        const sections = cartB
          .getSectionsToRender()
          .map((section) => section.id)
          .toString();
        post(variantId, 1, sections, (response) => {
          setTimeout(() => {
            cartB.renderContents(JSON.parse(response));
          });

          if (cartB && cartB.classList.contains('is-empty'))
            cartB.classList.remove('is-empty');

          // open mini cart
          const elem = document.getElementById('cart-icon-bubble');
          elem.dispatchEvent(new Event('click')); // Fire event
          get((res) => {
            // update count pill
            const { item_count } = JSON.parse(res);
            $(
              'header.mrHeader .header__icon .cart-count-bubble span[aria-hidden="true"]',
            ).html(item_count);
            const cart = JSON.parse(res);

            // update cart object with variants
            fetch('/cart.js')
              .then((res) => res.json())
              .then((data) => {
                data.items.map((item) => {
                  const cartItemIndex = cart.items.findIndex(
                    (i) => i.id === item.variant_id,
                  );
                  cart.items[cartItemIndex].variant = item.variant;
                });
              })
              .catch((err) => {
                // console.log(err, 'testing');
              });
          });
        });
      });
    } else {
      $('body').on('click', '.q-add-fix .cloned form button', function (e) {
        e.preventDefault();
        const $this = $(this);
        const variantId = $this.data('variant-id');
        const sections = cartB
          .getSectionsToRender()
          .map((section) => section.id)
          .toString();
        post(variantId, 1, sections, (response) => {
          setTimeout(() => {
            cartB.renderContents(JSON.parse(response));
          });

          if (cartB && cartB.classList.contains('is-empty'))
            cartB.classList.remove('is-empty');

          // open mini cart
          const elem = document.getElementById('cart-icon-bubble');
          elem.dispatchEvent(new Event('click')); // Fire event
          get((res) => {
            // update count pill
            const { item_count } = JSON.parse(res);
            $(
              'header.mrHeader .header__icon .cart-count-bubble span[aria-hidden="true"]',
            ).html(item_count);
            const cart = JSON.parse(res);

            // update cart object with variants
            fetch('/cart.js')
              .then((res) => res.json())
              .then((data) => {
                data.items.map((item) => {
                  const cartItemIndex = cart.items.findIndex(
                    (i) => i.id === item.variant_id,
                  );
                  cart.items[cartItemIndex].variant = item.variant;
                });
              })
              .catch((err) => {
                // console.log(err, 'testing');
              });
          });
        });
      });
    }
  }

  // quick add mobile
  function mobileQuickAdd() {
    const parentGrid = $('.hp-carousel ul.grid');
    const childItem = $(parentGrid).find('li.grid__item');

    $(childItem).each(function () {
      const btn = $(this).find(
        '.mobile-quick-toggle img, .mobile-quick-toggle',
      );

      $(btn).on('click', function () {
        const dataCard = $('.q-add-fix .variant-selector').attr('data-card');
        const parentDataCard = $(this)
          .parents('.card-wrapper')
          .attr('data-card');
        $('.q-add-fix').removeClass('hide');
        if (dataCard != parentDataCard) {
          $('.q-add-fix .cloned').remove();
          $(this)
            .parents('.card-wrapper')
            .find('.variant-selector')
            .clone()
            .addClass('cloned')
            .appendTo('.q-add-fix');
        }
      });
    });

    $('body').on('click', '.q-add-fix .variant-close', function () {
      $('.q-add-fix').addClass('hide');
    });
  }

  // post for quick add
  function post(id, quantity, sections, callback = () => {}) {
    const options = {
      method: 'POST',
      payload: {
        id,
        quantity,
        sections,
      },
      endpoint: '/cart/add.js',
      callback,
    };

    api_base(options);
  }
  // get for quick add
  function get(callback = () => {}) {
    const options = {
      method: 'GET',
      endpoint: '/cart.js',
      callback,
    };

    api_base(options);
  }
  // for quick add
  function api_base(options) {
    const { payload, method, endpoint, callback } = options;
    const myHeaders = new Headers();
    let raw;
    myHeaders.append('Content-Type', 'application/json');

    if (payload) {
      raw = JSON.stringify(payload);
    }

    const requestOptions = {
      method,
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(endpoint, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (result) {
          callback(result);
        }
      })
      .catch((error) => {
        // console.log('error', error);
      });
  }
};

export default homepage;
